import ListDevicesPage from './ListDevicesPage';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetAgencyByIdQuery } from '../../agencies/agency.api-slice';
import { useParams } from 'react-router-dom';

const ListDevicesForAgency: React.FC = () => {
  const { id } = useParams();
  const { data } = useGetAgencyByIdQuery(id ?? skipToken);

  return <ListDevicesPage agency={data} scope={'agency'} />;
};

export default ListDevicesForAgency;
